import React, { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import RdpListTab from "../tables/RdpListTab";
import { useDispatch, useSelector } from "react-redux";
import { getAllRdps, saveNewRdps } from "../store/actions/rdp";
import { IoClose, IoEyeOff, IoEye } from "react-icons/io5";
import { IoMdAdd } from "react-icons/io";
import { toast } from "react-toastify";
import { PANEL_TYPES,REMOTE_TYPES,SERVER_TYPES } from "../utills/constant";
import { Link } from "react-router-dom";

const RdpList = () => {
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [isModalFilter, setIsModalFilter] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("all");
  const [searchText, setSearchText] = useState("");
  const [showCloseButton, setShowCloseButton] = useState(false);
  const [rdpList, setRdpList] = useState([]);
  const [filterQuery, setFilterQuery] = useState({
    limit: "10",
    page: "1",
  });
  const [formData, setFormData] = useState({
    Name: "",
    location: "",
    serverType: "",
    remoteType: "",
    pannelType: "",
    serverConf: {
      hostName: "",
      port: "",
      userName: "",
      password: "",
    },
    pannelConf: {
      hostName: "",
      userName: "",
      password: "",
    },
  });

  // redux logic
  const rdps = useSelector((state) => state.rdps);

  const getRdpsList = () => {
    dispatch(getAllRdps(filterQuery));
  };

  useEffect(() => {
    getRdpsList();
  }, [dispatch, filterQuery, setFilterQuery]);

  useEffect(() => {
    setRdpList(rdps.rdpsList);
  }, [rdps]);

  const userHeader = [
    { key: "Name" },
    { key: "Location" },
    // { key: "Server" },
    { key: "Server Type" },
    { key: "Remote Connection" },
    { key: "Pannel Type" },
    { key: "Server Authentication" },
    { key: "Pannel Authentication" },
    { key: "Status" },
    { key: "Action" },
  ];
  const toggleModalFilter = () => {
    setIsModalFilter(!isModalFilter);
  };
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  const handleTabClick = (tab) => {
    if (tab === "all") {
      delete filterQuery.status;
      setFilterQuery({ ...filterQuery });
    } else if (tab === "active") {
      setFilterQuery({ ...filterQuery, status: "1" });
    } else if (tab === "inactive") {
      setFilterQuery({ ...filterQuery, status: "0" });
    }
    setActiveTab(tab);
  };

  const handleSearchText = (e) => {
    setSearchText(e.target.value);
  };
  const handleSearch = (e) => {
    e.preventDefault();
    setFilterQuery({
      ...filterQuery,
      keyword: e.target.defaultSearch.value,
      keywordName: ["Name", "hostName", "userName"],
    });
    setShowCloseButton(true);
  };
  const handleClearSearch = () => {
    delete filterQuery.keyword;
    delete filterQuery.keywordName;
    setFilterQuery({ ...filterQuery });
    setSearchText("");
    setShowCloseButton(false);
  };

  const handleSaveRdp = (e) => {
    e.preventDefault();
    dispatch(
      saveNewRdps(formData)
    );
    setFormData({
      Name: "",
      location: "",
      serverType: "",
      remoteType: "",
      pannelType: "",
      serverConf: {
        hostName: "",
        port: "",
        userName: "",
        password: "",
      },
      pannelConf: {
        hostName: "",
        userName: "",
        password: "",
      },
    });
    toast.success("New Rdp saved Successfully!", {
      position: "top-right", // Use string instead of POSITION.TOP_RIGHT
      autoClose: 600,
      onClose: () => {
        getRdpsList();
      },
    });
    setIsModalOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleNestedChange = (e, section) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [name]: value,
      },
    }));
  };

  return (
    <div className="relative">
      <div className=" bg-top p-1 fixed  w-full lg:max-w-[calc(100%-16rem)] z-10 !bg-[#cbd5e0]">
        <div className="flex items-center justify-between p-2  gap-4">
          {/* <div className="text-text text-lg  font-bold">RDP List</div> */}
          <div className="relative ">
            <form className=" flex w-full " onSubmit={handleSearch}>
              <span className="absolute inset-y-0 left-0 flex items-center pl-3  text-gray-500">
                <FaSearch />
              </span>

              <input
                type="text"
                id="default-search"
                value={searchText}
                onChange={handleSearchText}
                name="defaultSearch"
                placeholder="Search..."
                className="w-[275px]  pl-10 pr-4 py-2 text-gray-500 border border-gray-300 rounded-lg focus:outline-none focus:ring-0 focus:ring-blue-500"
              />
              <button
                type="submit"
                className="text-white  absolute right-0 bottom-1 top-1 bg-[#02256d] hover:bg-blue-800  focus:outline-none focus:ring-0 font-medium rounded-lg text-sm px-4 py-0 mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                Search
              </button>
              {showCloseButton && (
                <button
                  type="submit"
                  className="text-red-600 text-bold absolute right-20 bottom-1 top-1  focus:outline-none focus:ring-0 font-medium rounded-lg text-sm px-2 py-0 mr-2  "
                  onClick={handleClearSearch}
                >
                  X
                </button>
              )}
            </form>
          </div>

          <div className="w-full sm:w-auto flex flex-col lg:flex-row justify-around gap-2 lg:gap-4 mt-2">
            <div className="w-full flex items-center flex-row ">
              <Link
              to="/admin/rdpList/serviceAdd"
                // onClick={toggleModal}
                className="w-full sm:w-auto action-btn flex items-center justify-center gap-2 px-4 py-1 text-sm font-medium text-text  bg-[#fdbc12] p-2 h-[45px]  rounded-lg"
                // type="button"
              >
                <IoMdAdd /> Add Server 
              </Link>
              {/* Modal */}
              {/* {isModalOpen && (
              
              )} */}
            </div>
          </div>
        </div>
      </div>
      <div className="lg:pt-16 pt-[4rem]">
        <div className="flex flex-col sm:flex-row justify-between items-center w-full gap-4 bg-[#cbd5e0] p-3">
          {/* Title Section */}
          <div>
            <h2 className="text-lg font-medium text-text">RDP List</h2>
          </div>

          {/* Tabs Section */}
          <div>
            <ul
              className="flex flex-wrap -mb-px text-sm font-medium text-center"
              role="tablist"
            >
              {/* All Tab */}
              <li className="mr-4" role="presentation">
                <button
                  className={`px-4 py-1 rounded-lg transition-all duration-200 ${
                    activeTab === "all"
                      ? "bg-[#02256d] text-white shadow-md"
                      : "bg-gray-100 text-gray-500 hover:bg-gray-200"
                  }`}
                  id="all"
                  type="button"
                  role="tab"
                  aria-selected={activeTab === "all"}
                  onClick={() => handleTabClick("all")}
                >
                  All
                </button>
              </li>

              {/* Active Tab */}
              <li className="mr-4" role="presentation">
                <button
                  className={`px-4 py-1 rounded-lg transition-all duration-200 ${
                    activeTab === "active"
                      ? "bg-[#02256d] text-white shadow-md"
                      : "bg-gray-100 text-gray-500 hover:bg-gray-200"
                  }`}
                  id="active"
                  type="button"
                  role="tab"
                  aria-selected={activeTab === "active"}
                  onClick={() => handleTabClick("active")}
                >
                  Active
                </button>
              </li>

              {/* Inactive Tab */}
              <li className="mr-4" role="presentation">
                <button
                  className={`px-4 py-1 rounded-lg transition-all duration-200 ${
                    activeTab === "inactive"
                      ? "bg-[#02256d] text-white shadow-md"
                      : "bg-gray-100 text-gray-500 hover:bg-gray-200"
                  }`}
                  id="inactive"
                  type="button"
                  role="tab"
                  aria-selected={activeTab === "inactive"}
                  onClick={() => handleTabClick("inactive")}
                >
                  Inactive
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="p-2 bg-[#cbd5e0]">
        <RdpListTab
          userHeader={userHeader}
          userProducts={rdpList}
          loading={rdps.loading}
          totalCount={rdps.totalcount}
          fetchAllData={getRdpsList}
          filter={filterQuery}
          setFilter={setFilterQuery}
        />
      </div>
    </div>
  );
};

export default RdpList;
